// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {

}

.swiftref-filter-tags {
    display: flex;

}


`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/filter_tags/style/index.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,aAAa;;AAEjB","sourcesContent":[":host {\n\n}\n\n.swiftref-filter-tags {\n    display: flex;\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
